import {getId, getType} from 'apis/model/base'
import useTranslate from 'modules/local/useTranslate'
import React, {useContext} from 'react'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import OrganizationContainerContext from '../OrganizationContainerContext'
import {useHistory} from "../../../../modules/navigation/useRouter";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import renderPagingLoading from "../../../MainPage/functions/renderPagingLoading";
import CustomLazyPaginationWrapper from "../../../../modules/asyncCache/components/CustomLazyPaginationWrapper";
import {NullAsDefault} from "../../../Shared";
import {organization_getDepartments_Api} from "../../../../apis";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {DoubleValueItem, ItemInformation} from "../OrganizationEntity";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import {scrollToRow} from "../../Missal/functions/scrollToRow";
import {FiChevronsRight} from "react-icons/fi";
import {FaUsers} from "react-icons/fa6";
import {DelayRender} from "../../../Discovery/DelayRender";
import _ from "lodash"
import classNames from "classnames";
import {PiUserCircleCheckFill} from "react-icons/pi";
import {WrapperBlockSider} from "../components/WrapperBlockSider";
import {JoinButton} from "../../custom/ToggleActionButton";


const renderDepartment = ({t, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    return (
        <div
            key={item.id}
            className="px-3 py-2 background-50 hover:shadow-md rounded-xl hover:scale-2xs">
            <div className="mb-2 pb-2 border-b flex items-center gap-3">
                <FaUsers size={20} className="text-indigo-400"/>
                <div className="flex flex-col flex-1">
                    <Link to={getLinkToDetail(item)} className="text-color-000 no-underline">
                        <h2 className={classNames("font-bold text-base leading-snug items-baseline")}>
                            {item?.title}
                            {!!item?.active_as_member?.id && <PiUserCircleCheckFill className="ml-3 text-green-300"/>}
                        </h2>
                    </Link>
                    {item.department_group_title && (
                        <div className="text-xs text-indigo-400 italic leading-snug tracking-wider">
                            {item?.department_group_title}
                        </div>
                    )}
                </div>
            </div>
            <ItemInformation
                showIcon={true}
                value={`${item?.member_count} ${t('members')}`}
                className="text-xs"
            />
            <div className="flex justify-end">
                {!!item?.available_actions?.can_join && !!!item?.joined_status && (
                    <JoinButton
                        item={item}
                        id={getId(item)}
                        type={getType(item)}
                        size="small"
                        className="text-doc-xs rounded-full"
                    />
                )}
            </div>
        </div>
    )
}

const renderDepartmentGridItem = ({t, renderContextMenu = NullAsDefault} = {}) => (item, index) => {
    return (
        <div
            key={item.id}
            className="p-3 border border-color-50 background shadow-md hover:scale-2xs rounded-xl">
            <div className="mb-2 pb-2 border-b flex items-center gap-3">
                <FaUsers size={20} className="text-indigo-400"/>
                <div className="flex flex-col flex-1">
                    <Link to={getLinkToDetail(item)} className="text-color-000 no-underline">
                        <h2 className={classNames("font-bold text-lg leading-snug items-baseline")}>
                            {item?.title}
                            {
                                !!item?.active_as_member?.id && <PiUserCircleCheckFill className="ml-3 text-green-300"/>
                            }
                        </h2>
                    </Link>
                    {item.department_group_title && (
                        <div className="text-xs text-indigo-400 italic leading-snug tracking-wider">
                            {item?.department_group_title}
                        </div>
                    )}
                </div>
            </div>
            <ItemInformation
                showIcon={true}
                value={`${item?.member_count} ${t('members')}`}
                className="text-xs"
            />
            {item?.patron_saint_name && (
                <DoubleValueItem
                    showIcon={true}
                    labelFirst="patron saint"
                    valueFirst={item?.patron_saint_name}
                    labelSecond={item?.patron_saint_feast_day ? ' - ' : ''}
                    valueSecond={`(${item?.patron_saint_feast_day})`}
                    className="text-xs"
                />
            )}
            <div className="flex justify-end">
                {!!item?.available_actions?.can_join && !!!item?.joined_status && (
                    <JoinButton
                        item={item}
                        id={getId(item)}
                        type={getType(item)}
                        className="rounded-full"
                    />
                )}
            </div>
        </div>
    )
}

const OrganizationDepartments = () => {
    const t = useTranslate()
    const {organization: item} = useContext(OrganizationContainerContext)
    const {isLg} = useContext(LayoutContext)
    const owner_id = getId(item)
    const owner_type = getType(item)
    const history = useHistory()

    return (
        <CustomLazyPaginationWrapper
            auto={false}
            sample={2}
            apiInfo={organization_getDepartments_Api}
            renderItem={renderDepartment({t})}
            renderLoading={renderPagingLoading}
            id={[organization_getDepartments_Api.path, item?.id].join("/")}
            query={bindQueryParams([{id: owner_id}])}
            renderWrap={(children, __, count) => {
                return !!count && (
                    <WrapperBlockSider
                        title="groups / ministries" titleColor="text-indigo-700" expanded={!isLg}
                        borderLeft={isLg}
                        borderTop={!isLg}
                        icon={<FaUsers size={18} className="text-indigo-400"/>}>
                        <div className="flex flex-col gap-4">
                            {children}
                        </div>
                    </WrapperBlockSider>
                )
            }}
            renderLoadMore={() => (
                <span
                    className="flex items-center justify-end gap-1 text-color-400 hover:text-color-100 cursor-pointer"
                    onClick={() => {
                        scrollToRow('contentOrg');
                        history.push(getLinkToDetail(item) + '/groups')
                    }}>
                    <span className="text-xs italic">
                        {t('see more')}
                    </span>
                    <FiChevronsRight size={13} className="my-auto"/>
                </span>
            )}
        />
    )
}

export const OrganizationDepartmentsGrid = () => {
    const t = useTranslate()
    const {organization: item} = useContext(OrganizationContainerContext)
    const owner_id = getId(item)

    return (
        <div className="flex flex-col gap-6">
            <div className="flex flex-col gap-1">
                <h2 className="font-bold text-lg text-gray-800 tracking-wide uppercase">
                    {t('groups / ministries')}
                </h2>
                <div className="text-color-300 tracking-wider">
                    {t('groups / ministries description')}
                </div>
            </div>
            {_.get(item, 'group_numbers', [1]).map((group_nbr, index) => (
                <React.Fragment key={index}>
                    <DelayRender lazy={index !== 0} time={group_nbr * 150}>
                        <CustomLazyPaginationWrapper
                            apiInfo={organization_getDepartments_Api}
                            values={{group_nbr}}
                            renderItem={renderDepartmentGridItem({t})}
                            renderLoading={renderPagingLoading}
                            id={[organization_getDepartments_Api.path, item?.id, group_nbr].join("/")}
                            query={bindQueryParams([{id: owner_id}])}
                            renderWrap={(children, __, count) => {
                                return !!count && (
                                    <div className="p-2 flex flex-col gap-4">
                                        <div className="flex flex-col gap-4">
                                            <HeaderWithIconLine
                                                renderTitle={() => (
                                                    <span
                                                        className="font-bold text-sm text-color-200 uppercase tracking-wider">
                                                        {_.get(item, 'groups.' + group_nbr) || t("list of group / ministry")}
                                                    </span>
                                                )}
                                            />
                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                {children}
                                            </div>
                                        </div>
                                    </div>
                                )
                            }}
                        />
                    </DelayRender>
                </React.Fragment>
            ))}
        </div>
    )
}

export default OrganizationDepartments
